import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "parent-container container-fluid container-sm flex-sm-column flex-md-column flex-lg-row pb-5" }
const _hoisted_2 = { class: "col-sm-12 col-md-12 col-lg-8" }
const _hoisted_3 = { class: "parent-container__child-1 col-12" }
const _hoisted_4 = { class: "parent-container__child-2 col-12" }
const _hoisted_5 = { class: "parent-container__child-3 col-12" }
const _hoisted_6 = { class: "col-sm-12 col-md-12 col-lg-4" }
const _hoisted_7 = { class: "parent-container__child-4 col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "order-info")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "vehicle-info")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "payment-type")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "order-form")
      ])
    ])
  ]))
}